import { render } from "./App.vue?vue&type=template&id=4b72090c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4b72090c&lang=css"

import exportComponent from "/builds/appmart-development-team/appmart-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__